import visigalogo from "../assets/visigalogo.png";
import hailmary3 from "../assets/hailmary3.png";
import { useTranslation } from "react-i18next";
import { FaTiktok, FaInstagram, FaYoutube } from "react-icons/fa";

const ContactUs = () => {

    const { t } = useTranslation();

    return (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0 h-auto dark:bg-gray-800 min-h-screen">
            {/* First Portion (3 grid) - Logo and Seminary Name */}
            <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
                <h1 className="text-3xl sm:text-xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
                    {t("schoolName")}{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2">
                        {t("schoolSub")}
                    </span>
                </h1>
                <img
                    src={visigalogo}
                    alt="Visiga Seminary Logo"
                    className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
                />
            </div>

            {/* Middle Portion (6 grid) - Contact Information */}
            <div className="lg:col-span-6 flex flex-col items-center mt-1 lg:mt-0 dark:bg-gray-800 space-y-8">
                {/* Admission Section */}
                <div className="w-full bg-white dark:bg-gray-700 p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
                    <h1 className="text-3xl sm:text-4xl lg:text-3xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
                        {t("contact.title")}
                    </h1>

                    <div className="space-y-6">
                        <div>
                            <h2 className="text-2xl text-center font-semibold text-blue-600 dark:text-blue-400 mb-3">
                                {t("contact.call")}
                            </h2>
                            <ul className="space-y-2 text-lg text-center text-gray-700 dark:text-gray-300">
                                <li className="flex items-center justify-center space-x-2">
                                    <span>📞</span>
                                    <span>+255 655 330 260</span>
                                </li>
                                <li className="flex items-center justify-center space-x-2">
                                    <span>📠</span>
                                    <span>+255 767927537</span>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-2xl text-center font-semibold text-blue-600 dark:text-blue-400 mb-3">
                                {t("contact.email")}
                            </h2>
                            <ul className="space-y-2 text-lg text-center text-gray-700 dark:text-gray-300">
                                <li className="flex items-center justify-center space-x-2">
                                    <span>📩</span>
                                    <a href="mailto:visigaseminary@gmail.com" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                                        st.mary_seminary@yahoo.com
                                    </a>
                                </li>
                                <li className="flex items-center justify-center space-x-2">
                                    <span>📧</span>
                                    <a href="mailto:visigaseminary@yahoo.com" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                                        st.mary_seminary@yahoo.com
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>



                {/* Visit Us Section */}
                <div className="w-full bg-white dark:bg-gray-700 p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
                    <h1 className="text-3xl sm:text-4xl lg:text-3xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
                        {t("contact.visit-us")}
                    </h1>

                    <ul className="space-y-3 text-lg text-center text-gray-700 dark:text-gray-300">
                        <li className="flex items-center justify-center space-x-2">
                            <span>🏠</span>
                            <span>St. Mary's Junior Seminary</span>
                        </li>
                        <li className="flex items-center justify-center space-x-2">
                            <span>📍</span>
                            <span>P. O. Box 127</span>
                        </li>
                        <li className="flex items-center justify-center space-x-2">
                            <span>📍</span>
                            <span>morogoro Road / kwa kipofu / Visiga /  Coast-region / Tanzania</span>
                        </li>
                        <li className="flex items-center justify-center space-x-2">
                            <span>📍</span>
                            <span>Tanzania</span>
                        </li>
                    </ul>
                </div>

                {/* Social Media Section */}
                <div className="w-full bg-white dark:bg-gray-700 p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300">
                    <h1 className="text-3xl sm:text-4xl lg:text-3xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
                        {t("contact.social")}
                    </h1>

                    <div className="flex justify-center gap-6 text-gray-700 dark:text-gray-300">
                        <a
                            href="https://www.tiktok.com/@visigaseminary?_t=ZM-8yq9jAQpwRB&_r=1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-pink-600 dark:hover:text-pink-400 transition-colors flex items-center gap-2"
                        >
                            <FaTiktok size={24} />
                            <span>TikTok</span>
                        </a>

                        <a
                            href="https://www.instagram.com/visigaseminary?igsh=MWhveWlxbGU1NWRoag=="
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-purple-600 dark:hover:text-purple-400 transition-colors flex items-center gap-2"
                        >
                            <FaInstagram size={24} />
                            <span>Instagram</span>
                        </a>

                        <a
                            href="https://youtube.com/@visigaseminarytv?feature=shared"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-red-600 dark:hover:text-red-400 transition-colors flex items-center gap-2"
                        >
                            <FaYoutube size={24} />
                            <span>YouTube</span>
                        </a>
                    </div>
                </div>

            </div>

            {/* Third Portion (3 grid) - Image Section */}
            <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
                <img
                    src={hailmary3}
                    alt="Hail Mary"
                    className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-102 transition-transform duration-300"
                />
                <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
                    {t("motherText")}
                </p>
            </div>
        </div>
    );
};

export default ContactUs;